<mat-icon class="text-icon" (click)="onClick()" [matTooltip]="tooltip">{{icon}}</mat-icon>